import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import {
  ALL_VEHICLE_LOCATION_TYPES,
  VEHICLE_LOCATION_TYPE_CONFIG,
} from "services/api/fleet/vehicles/locations/consts";

/** Vrste lokacije za filter — isti popis i nazivi kao u unosu premještaja. */
export const VEHICLE_LOCATION_TYPE_OPTIONS: DropdownOption[] =
  ALL_VEHICLE_LOCATION_TYPES.map((type) => ({
    value: type,
    text: VEHICLE_LOCATION_TYPE_CONFIG[type].label,
  }));

/** Je li premještaj trenutna lokacija vozila ili je već zatvoren. */
export const TRANSFER_ACTIVE_OPTIONS: DropdownOption[] = [
  { value: "true", text: "Trenutne lokacije" },
  { value: "false", text: "Prošle lokacije" },
];
